module.exports = {
	"ha": "vcha",
	"id": 5.7,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2019 Q1–2020 Q4",
		"lastYear": "2020",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by HSDA, Year Ending 2020 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -140,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.91044776119404,
						"dataLabels": {
							"enabled": true,
							"format": "328"
						}
					},
					{
						"y": 89.8507462686567,
						"dataLabels": {
							"enabled": true,
							"format": "301"
						}
					},
					{
						"y": 85.97014925373134,
						"dataLabels": {
							"enabled": true,
							"format": "288"
						}
					},
					{
						"y": 81.7910447761194,
						"dataLabels": {
							"enabled": true,
							"format": "274"
						}
					},
					{
						"y": 58.2089552238806,
						"dataLabels": {
							"enabled": true,
							"format": "195"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.71428571428571,
						"dataLabels": {
							"enabled": true,
							"format": "171"
						}
					},
					{
						"y": 92,
						"dataLabels": {
							"enabled": true,
							"format": "161"
						}
					},
					{
						"y": 85.14285714285714,
						"dataLabels": {
							"enabled": true,
							"format": "149"
						}
					},
					{
						"y": 78.28571428571428,
						"dataLabels": {
							"enabled": true,
							"format": "137"
						}
					},
					{
						"y": 62.857142857142854,
						"dataLabels": {
							"enabled": true,
							"format": "110"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.76968593536641,
						"dataLabels": {
							"enabled": true,
							"format": "4296"
						}
					},
					{
						"y": 83.59126081019572,
						"dataLabels": {
							"enabled": true,
							"format": "3673"
						}
					},
					{
						"y": 78.22030040964952,
						"dataLabels": {
							"enabled": true,
							"format": "3437"
						}
					},
					{
						"y": 72.16659080564406,
						"dataLabels": {
							"enabled": true,
							"format": "3171"
						}
					},
					{
						"y": 54.18752844788348,
						"dataLabels": {
							"enabled": true,
							"format": "2381"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.0895522388059695,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.231707317073166,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.318936877076407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.861111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.832116788321173,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.285714285714291,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.847953216374268,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.453416149068326,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.053691275167784,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.70802919708029,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.2303140646335873,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.501862197392922,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.425265450585349,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.739307535641549,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.913276568905708,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "North Shore/Coast Garibaldi<br>n=335"
			},
			{
				"x": 9,
				"text": "Richmond<br>n=175"
			},
			{
				"x": 15,
				"text": "Vancouver<br>n=4394"
			}
		],
		"dataTable": {
			"North Shore / Coast Garibaldi": [
				335,
				328,
				301,
				288,
				274,
				195
			],
			"Richmond": [
				175,
				171,
				161,
				149,
				137,
				110
			],
			"Vancouver": [
				4394,
				4296,
				3673,
				3437,
				3171,
				2381
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_7.json
// module id = 308
// module chunks = 0